import Tooltip from '@anm/components/Tooltip';
import noop from '@anm/helpers/noop';
import { getLinkTarget } from '@anm/helpers/upgradeLink';
import React, { FC } from 'react';

import { AddToBrandButton, Wrapper } from './Wrapper';
import { notStableTooltip } from '@anm/components/dropdown-actions/NotStableTooltip';

type AddToBrandButtonProps = {
  publishUrl: string;
  isDisabled: boolean;
  onButtonClick: () => void;
  isNotStable?: boolean;
  canEditBrand?: boolean;
};

const AddToBrand: FC<AddToBrandButtonProps> = ({
  publishUrl,
  isNotStable,
  canEditBrand,
  onButtonClick,
  isDisabled
}) => {
  const canNoteditBrandTooltip = () => (
    <>
      Please{' '}
      <a href={publishUrl} target="_blank">
        upgrade
      </a>{' '}
      to add it to brand.
    </>
  );

  const publishTooltip = () => (
    <>
      This video has not been published yet.{' '}
      <a href={publishUrl} target={getLinkTarget()}>
        Publish it in the editor
      </a>{' '}
      to add it to brand.
    </>
  );

  const tooltip = isNotStable ? notStableTooltip : !canEditBrand ? canNoteditBrandTooltip : publishTooltip;

  return (
    <Wrapper>
      <Tooltip delayShow={300} delayHide={300} direction="to-bottom" renderContent={isDisabled ? tooltip : undefined}>
        <AddToBrandButton
          size="large"
          icon="images/icons/brand_icon_blue.svg"
          iconSize="small"
          variant="white-blue-border-share"
          onClick={isDisabled ? noop : onButtonClick}
          disabled={isDisabled}
        >
          Send to Live Studio
        </AddToBrandButton>
      </Tooltip>
    </Wrapper>
  );
};

export default AddToBrand;
